import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Teaser Counter",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-teaser-counter",
    args: {
        title: "Mio. Euro",
        subtitle: "Aaufwendungen für Forschung",
        decimalSeparator: ".",
        decimalsCount: "2",
        noAnimation: "false",
        number: 377.4,
        prefixValue: "",
        suffixValue: "",
        thousandsSeparator: ",",
    },
    argTypes: {
        title: {
            control: "text",
        },
        subtitle: {
            control: "text",
        },
        decimalSeparator: {
            control: "text",
        },
        decimalsCount: {
            control: "number",
        },
        noAnimation: {
            control: "boolean",
        },
        number: {
            control: "text",
        },
        prefixValue: {
            control: "text",
        },
        suffixValue: {
            control: "text",
        },
        thousandsSeparator: {
            control: "text",
        },
    },
};

const Template = ({
    title,
    subtitle,
    decimalSeparator,
    decimalsCount,
    noAnimation,
    number,
    prefixValue,
    suffixValue,
    thousandsSeparator,
}) =>
    html` <ux-iws-teaser-counter
        decimal-separator="${decimalSeparator}"
        decimals-count="${decimalsCount}"
        no-animation="${noAnimation}"
        number="${number}"
        prefix-value="${prefixValue}"
        suffix-value="${suffixValue}"
        thousands-separator="${thousandsSeparator}"
    >
        <div
            class="ux-text-tiny ux-text-tiny--bold
        ux-u-text-uppercase ux-u-margin-bottom-0"
        >
            ${title}
        </div>
        <div class="ux-text-tiny ux-u-text-uppercase">${subtitle}</div>
    </ux-iws-teaser-counter>`;

export const Default = Template.bind({});

const TemplateGrid = ({
    title,
    subtitle,
    decimalSeparator,
    decimalsCount,
    noAnimation,
    number,
    prefixValue,
    suffixValue,
    thousandsSeparator,
    gridItems,
}) => html`
    <div class="ux-row">
        <div class="ux-col-12">
            <div class="ux-u-margin-bottom-10 ux-u-margin-xl-bottom-30">
                <div class="ux-iws-teaser-counter-grid">
                    <div class="ux-u-margin-bottom-30">
                        <ux-iws-teaser-counter
                            decimal-separator="${decimalSeparator}"
                            decimals-count="${decimalsCount}"
                            no-animation="${noAnimation}"
                            number="${number}"
                            prefix-value="${prefixValue}"
                            suffix-value="${suffixValue}"
                            thousands-separator="${thousandsSeparator}"
                        >
                            <div
                                class="ux-text-tiny ux-text-tiny--bold
                                    ux-u-text-uppercase ux-u-margin-bottom-0"
                            >
                                ${title}
                            </div>
                            <div class="ux-text-tiny ux-u-text-uppercase">
                                ${subtitle}
                            </div>
                        </ux-iws-teaser-counter>
                    </div>
                    <div class="ux-u-margin-bottom-30">
                        <ux-iws-teaser-counter
                            decimal-separator="${decimalSeparator}"
                            decimals-count="1"
                            no-animation="${noAnimation}"
                            number="10.8"
                            prefix-value="${prefixValue}"
                            suffix-value="${suffixValue}"
                            thousands-separator="${thousandsSeparator}"
                        >
                            <div
                                class="ux-text-tiny ux-text-tiny--bold
                                    ux-u-text-uppercase ux-u-margin-bottom-0"
                            >
                                Entwicklungsquote
                            </div>
                            <div class="ux-text-tiny ux-u-text-uppercase">
                                In Relation zum Umsatz
                            </div>
                        </ux-iws-teaser-counter>
                    </div>
                    ${gridItems > 2
                        ? html` <div class="ux-u-margin-bottom-30">
                              <ux-iws-teaser-counter
                                  decimal-separator="${decimalSeparator}"
                                  decimals-count="0"
                                  no-animation="${noAnimation}"
                                  number="2201"
                                  prefix-value="${prefixValue}"
                                  suffix-value="${suffixValue}"
                                  thousands-separator="${thousandsSeparator}"
                              >
                                  <div
                                      class="ux-text-tiny ux-text-tiny--bold
                                        ux-u-text-uppercase ux-u-margin-bottom-0"
                                  >
                                      Mitarbeiter
                                  </div>
                                  <div class="ux-text-tiny ux-u-text-uppercase">
                                      Die an neuen Produkten arbeiten
                                  </div>
                              </ux-iws-teaser-counter>
                          </div>`
                        : html``}
                </div>
            </div>
        </div>
    </div>
`;

export const Grid = TemplateGrid.bind({});
Grid.args = {
    gridItems: 2,
};

Grid.argTypes = {
    gridItems: {
        control: {
            type: "range",
            min: 2,
            max: 3,
            step: 1,
        },
    },
};
